import React, {useState, useRef, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import TableComponent from '../../Atoms/TableComponent';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import HistoryIcon from '@mui/icons-material/History';
import Tooltip from '@mui/material/Tooltip';
import Skeleton from "@mui/material/Skeleton";
import moment, { duration } from "moment";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Table, TableCell, TableRow } from "@mui/material";
import { Check, Clear, Event } from "@material-ui/icons";
import { url } from '../../../Config';
import axios from 'axios';
import ApprovalIcon from '@mui/icons-material/Approval';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

export default function Fund_history(props) {

    const Navigate = useNavigate();
    const { id } = useParams();
    const userid = localStorage.getItem("userID");
    const [data, setdata] = useState([]);
    const [bool, setbool] = useState(false);
    const [alertopen, setalertOpen] = useState(false);
    const [alertType, setalertType] = useState();
    const [AlertMessage, setalertmessage] = useState();
    const [alertopen2, setalertOpen2] = useState(false);
    const [alertType2, setalertType2] = useState();
    const [AlertMessage2, setalertmessage2] = useState();
    const [alertopen3, setalertOpen3] = useState(false);
    const [alertType3, setalertType3] = useState();
    const [AlertMessage3, setalertmessage3] = useState();
    const [period, setperiod] = useState();
    const [fund_size, setfund_size] = useState();
    const [category_size, setcategory_size] = useState();
    const [fund_nav, setfund_nav] = useState();
    const [fund_d, setfund_d] = useState();
    const [wam, setwam] = useState();
    const [duration, setduration] = useState();
    const [value, setValue] = useState(null);
    const [formatted, setFormatted] = useState("");

    useEffect(()=>{

        setdata([])
        const func = async ()=>{
            const res = await axios.get(`${url}/api/get_fund_history/${id}`);
            const resp = res.data;
            setdata(resp);
        }
        func();

    },[bool])


    const deleteitem = async(id)=>{
        Swal.fire({ title: 'Do you want to delete this Record?', 
    showDenyButton: false, showCancelButton: true, confirmButtonText: 'Delete'})
    .then(async(result) => {
        
      if (result.isConfirmed) {
        const res = await axios.get(`${url}/api/delete_interval_record/${id}`);
        const resp = res.data;
        if(resp.status == true){
            setalertOpen(true);
            setalertmessage(resp.message);
            setalertType("success");
            setbool(!bool);
        }
        else{
            setalertOpen(true);
            setalertmessage(resp.message);  
            setalertType("error")
        }
      }
    })
        
    }

    const addnewInterval = async (event)=>{

        event.preventDefault();
        const res =  await axios.post(`${url}/api/add_new_interval`, {
            'op_id': id, 'period' : formatted, 'fund_size' : fund_size,
            'category_size' : category_size, 'fund_nav' : fund_nav, 'fund_dividend' : fund_d,
            'wam' : wam, 'duration' : duration
        });
        const resp = res.data;
        if(resp.status == true){
            window.location.reload();
        }
        else{
            setalertOpen2(true);
            setalertmessage2(resp.message);  
            setalertType2("error");
        }                                                                                                   
    }



        const responsiveColumns = () => {
        if (props.screenWidth < 770) {
            return null;
        } else {
            return 120;
        }
        };

      const responsiveColumnPin = () => {
        if (props.screenWidth < 770) {
          return null;
        } else {
          return "left";
        }
      };

      const detailShow = () => {
        if (props.screenWidth < 770) {
          return false;
        } else {
          return true;
        }
      };
    
      const columnHide = () => {
        if (props.screenWidth < 770) {
          return true;
        } else {
          return false;
        }
      };
    
      const datefilters = (
        startDate,
        endDate,
        gridApi,
        getFilterType
      ) => {
        var dateFilterComponent =
          gridApi.api.getFilterInstance("date_rating_assigned");
        dateFilterComponent.setModel({
          type: getFilterType(),
          inRange: true,
          dateFrom: startDate,
          dateTo: endDate,
        });
      };
    

      const cellrander = (params) => {
        if (params.value === "nullData") return <Skeleton />;
        if (params.value === "" || params.value == null || params.value == 'total') {
          return "-";
        } else {
          return params.value;
        }
      };

      const cellrandered = (params) => {
        if (params.value === "nullData") {
          return <Skeleton />;
        } else {
          return params.value;
        }
      };

      const editInterval = async (event, editid) => {

        event.preventDefault();

        const editperiod = document.getElementById(`period${editid}`).value
        const editfund_size = document.getElementById(`fund_size${editid}`).value
        const editcategory_size = document.getElementById(`category_size${editid}`).value
        const editfund_nav = document.getElementById(`fund_nav${editid}`).value
        const editfund_dividend = document.getElementById(`fund_dividend${editid}`).value
        const editwam = document.getElementById(`wam${editid}`).value
        const editduration = document.getElementById(`duration${editid}`).value

        const res = await axios.post(`${url}/api/edit_interval_record`,{
            'id': editid, 'period' : editperiod, 'fund_size' : editfund_size,
            'category_size' : editcategory_size, 'fund_nav' : editfund_nav, 'fund_dividend' : editfund_dividend,
            'wam' : editwam, 'duration' : editduration
        })

        const resp = res.data;

         if(resp.status == true){
            window.location.reload();
        }
        else{
            setalertOpen3(true);
            setalertmessage3(resp.message);
            setalertType3("error");
        }
      }

    const columnDefs = [
        {
          headerName: "",
          field: "sNo",
          maxWidth: 30,
          filter: true,
          menuTabs: false,
          pinned: responsiveColumnPin(),
          hide: detailShow(),
          cellRenderer: "agGroupCellRenderer",
          suppressColumnsToolPanel: true,
          suppressFiltersToolPanel: true,
        },
        {
          headerName: "#",
          maxWidth: 50,
          // minWidth: 66,
          field: "sNo",
          sortable: true,
          filter: true,
          // filter: "agSetColumnFilter",
          headerComponentParams: {
            template:
              '<div class="ag-cell-label-container" role="presentation">' +
              '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
              '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
              '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
              '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
              '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
              '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
              '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
              '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
              "  </div>" +
              "</div>",
          },
          suppressFiltersToolPanel: true,
          menuTabs: false,
          cellRenderer: cellrandered,
          pinned: responsiveColumnPin(),
        },
        {
          headerName: "Period",
          minWidth: 250,
          field: "period",
          sortable: true,
          filter: "agSetColumnFilter",
          excelMode: "windows",
          cellRenderer: cellrander,
          tooltipField: "period",
          pinned: responsiveColumnPin(),
        },
        {
          headerName: "Fund Size (PKR mln)",
          field: "fund_size",
          minWidth: responsiveColumns(),
          sortable: true,
          filter: "agSetColumnFilter",
          excelMode: "windows",
          hide: columnHide(),
          cellRenderer: cellrander,
          tooltipField: "fund_size",
          // pinned: responsiveColumnPin(),
        },  
        {
          headerName: "Category Size",
          field: "category_size",
          minWidth: responsiveColumns(),
          sortable: true,
          filter: "agSetColumnFilter",
          excelMode: "windows",
          hide: columnHide(),
          cellRenderer: cellrander,
          tooltipField: "category_size",
        },
        {
          headerName: "Fund Nav (PKR/unit)",
          field: "fund_nav",
          minWidth: responsiveColumns(),
          sortable: true,
          filter: "agSetColumnFilter",
          excelMode: "windows",
          hide: columnHide(),
          cellRenderer: cellrander,
          tooltipField: "fund_nav",
        },
        {
          headerName: "Fund Dividend (PKR/unit)",
          field: "fund_dividend",
          minWidth: responsiveColumns(),
          sortable: true,
          filter: "agSetColumnFilter",
          excelMode: "windows",
          hide: columnHide(),
          cellRenderer: cellrander,
          tooltipField: "fund_dividend",
        },
        {
            headerName: "Wam (Days)",
            minWidth: 150,
            field: "wam",
            sortable: true,
            filter: "agSetColumnFilter",
            excelMode: "windows",
            hide: columnHide(),
            cellRenderer: cellrander,
            tooltipField: "wam",
        },
        {
            headerName: "Duration (Days)",
            minWidth: 150,
            field: "duration",
            sortable: true,
            filter: "agSetColumnFilter",
            excelMode: "windows",
            hide: columnHide(),
            cellRenderer: cellrander,
            tooltipField: "duration",
        },
        {
                    headerName: "Action",
                    minWidth: 150,
                    field: "",
                    sortable: true,
                    filter: "agSetColumnFilter",
                    excelMode: "windows",
                    cellRenderer: (params)=>{
                        return(
                                  <div>
                                      <Tooltip title="Edit"><EditIcon sx={{color: 'yellow'}} data-bs-toggle="modal" data-bs-target={`#editmodel${params.data.id}`} /></Tooltip>
                                      <Tooltip title="Delete"><DeleteIcon sx={{color: 'red'}} onClick={()=>{deleteitem(params.data.id)}}/></Tooltip>
                                  </div>
                              )
                        
                    },
                },
             
      ];

      const MobViewRender = (params) => (
        <h1 style={{ padding: "10px 20px" }}>
           <Table className="overflow-scroll responsiveTableFonts">
            <TableRow>
              <TableCell
                variant="head"
                className="fw-bolder responsiveTableFonts py-1"
              >
                Fund Size
              </TableCell>
              <TableCell className="responsiveTableFonts py-1">
                {params.data.fund_size}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                variant="head"
                className="fw-bolder responsiveTableFonts py-1"
              >
                Category Size
              </TableCell>
              <TableCell className="responsiveTableFonts py-1">
                {params.data.category_size}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                variant="head"
                className="fw-bolder responsiveTableFonts py-1"
              >
                Fund Nav (PKR/unit)
              </TableCell>
              <TableCell className="responsiveTableFonts py-1">
                {params.data.fund_nav}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                variant="head"
                className="fw-bolder responsiveTableFonts py-1"
              >
                Fund Dividend (PKR/unit)
              </TableCell>
              <TableCell className="responsiveTableFonts py-1">
                {params.data.fund_dividend}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                variant="head"
                className="fw-bolder responsiveTableFonts py-1"
              >
                Wam (Days)
              </TableCell>
              <TableCell className="responsiveTableFonts py-1">
                {params.data.wam}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                variant="head"
                className="fw-bolder responsiveTableFonts py-1"
              >
                Duration (Days)
              </TableCell>
              <TableCell className="responsiveTableFonts py-1">
                {params.data.duration}
              </TableCell>
            </TableRow>
          </Table>
        </h1>
      );

      const handleChange = (newValue) => {
    setValue(newValue);

    let formattedValue = "";

    if (newValue) {
      formattedValue = newValue
        .toLocaleString("en-US", {
          month: "short",
          year: "2-digit"
        })
        .replace(" ", "-");
    }

    setFormatted(formattedValue);
  };

  return (
    <div>
      <div className='text-center mt-2 fs-4 fw-bold' style={{color: "#000078" }}>
        Fund History
      </div>
      <div className='mt-2 mb-2'>
            <button className='btn btn-primary me-2 mb-lg-0 mb-md-0 md-sm-1 mb-1' data-bs-toggle="modal" data-bs-target="#staticBackdropDetail" >Add New Interval</button>
      </div>
        <form className="modal fade mt-5" id="staticBackdropDetail" tabIndex="-1" aria-labelledby="staticBackdrop" aria-hidden="true" onSubmit={(event)=>{addnewInterval(event)}}>
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdropLabelD">Add New Interval</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div className="modal-body" style={{height : "420px", overflow: "scroll"}}>
                      <Box className="mx-auto mb-1" sx={{ width: "98%" }}>
                          <Collapse in={alertopen2}>
                              <Alert
                                  severity={alertType2}
                                  action={
                                      <IconButton
                                        aria-label="close"
                                        color="inherit"
                                        size="small"
                                        onClick={() => {
                                          setalertOpen2(false);
                                        }}
                                      >
                                        <CloseIcon fontSize="inherit" />
                                      </IconButton>
                                    }
                                  sx={{ mb: 2 }}
                                >
                                  {AlertMessage2}
                              </Alert>
                          </Collapse>
                    </Box>
                        <div className="col-10 mx-auto">
                            <div>
                            <label className="fw-bold fs-6">Period:</label>
                            <div>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    views={["year", "month"]}
                                    label="Select Month & Year"
                                    value={value}
                                    onChange={handleChange}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                                </LocalizationProvider>
                                <input className='form-control mt-2' value={formatted} placeholder='Mar-24' disabled />
                            </div>
                            </div>
                            <div className="mt-1">
                            <label className="fw-bold fs-6">Fund Size:</label>
                            <div>
                                <input className="form-control" type="number" step="0.0001" value={fund_size} onChange={(e)=>{setfund_size(e.target.value)}}></input>
                            </div>
                            </div>
                            <div className="mt-1">
                            <label className="fw-bold fs-6">Category Size:</label>
                            <div>
                                <input className="form-control" type="number" step="0.0001" value={category_size} onChange={(e)=>{setcategory_size(e.target.value)}}></input>
                            </div>
                            </div>
                            <div className="mt-1">
                            <label className="fw-bold fs-6">Fund Nav (PKR/unit):</label>
                            <div>
                                <input className="form-control" type="number" step="0.0001" value={fund_nav} onChange={(e)=>{setfund_nav(e.target.value)}}></input>
                            </div>
                            </div>
                            <div className="mt-1">
                            <label className="fw-bold fs-6">Fund Dividend (PKR/unit):</label>
                            <div>
                                <input className="form-control" type="number" step="0.0001" value={fund_d} onChange={(e)=>{setfund_d(e.target.value)}}></input>
                            </div>
                            </div>
                            <div className="mt-1">
                            <label className="fw-bold fs-6">Wam (Days):</label>
                            <div>
                                <input className="form-control" type="number" step="0.0001" value={wam} onChange={(e)=>{setwam(e.target.value)}}></input>
                            </div>
                            </div>
                            <div className="mt-1">
                            <label className="fw-bold fs-6">Duration (Days):</label>
                            <div>
                                <input className="form-control" type="number" step="0.0001" value={duration} onChange={(e)=>{setduration(e.target.value)}}></input>
                            </div>
                            </div>
                        </div>
                        <div className="mt-3 mx-auto" style={{width: "fit-content"}}>
                            <button type="submit" className="btn btn-primary">Submit</button>
                        </div>
                  </div>
                </div>
              </div>
        </form>
        {
            data.map((value, index)=>{
                return(
                    <form className="modal fade mt-5" id={`editmodel${value.id}`} tabIndex="-1" aria-labelledby="staticBackdrop" aria-hidden="true" onSubmit={(event)=>{editInterval(event, value.id)}}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="staticBackdropLabelD">Edit Interval Record</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body" style={{height : "420px", overflow: "scroll"}}>
                                <Box className="mx-auto mb-1" sx={{ width: "98%" }}>
                                    <Collapse in={alertopen3}>
                                        <Alert
                                            severity={alertType3}
                                            action={
                                                <IconButton
                                                    aria-label="close"
                                                    color="inherit"
                                                    size="small"
                                                    onClick={() => {
                                                    setalertOpen2(false);
                                                    }}
                                                >
                                                    <CloseIcon fontSize="inherit" />
                                                </IconButton>
                                                }
                                            sx={{ mb: 2 }}
                                            >
                                            {AlertMessage3}
                                        </Alert>
                                    </Collapse>
                                </Box>
                                    <div className="col-10 mx-auto">
                                        <div>
                                        <label className="fw-bold fs-6">Period:</label>
                                        <div>
                                            <input className='form-control' id={`period${value.id}`} defaultValue={value.period} placeholder='Mar-24' />
                                        </div>
                                        </div>
                                        <div className="mt-1">
                                        <label className="fw-bold fs-6">Fund Size:</label>
                                        <div>
                                            <input className="form-control" type="number" step="0.0001" id={`fund_size${value.id}`} defaultValue={value.fund_size}></input>
                                        </div>
                                        </div>
                                        <div className="mt-1">
                                        <label className="fw-bold fs-6">Category Size:</label>
                                        <div>
                                            <input className="form-control" type="number" step="0.0001" id={`category_size${value.id}`} defaultValue={value.category_size}></input>
                                        </div>
                                        </div>
                                        <div className="mt-1">
                                        <label className="fw-bold fs-6">Fund Nav (PKR/unit):</label>
                                        <div>
                                            <input className="form-control" type="number" step="0.0001" id={`fund_nav${value.id}`} defaultValue={value.fund_nav}></input>
                                        </div>
                                        </div>
                                        <div className="mt-1">
                                        <label className="fw-bold fs-6">Fund Dividend (PKR/unit):</label>
                                        <div>
                                            <input className="form-control" type="number" step="0.0001" id={`fund_dividend${value.id}`} defaultValue={value.fund_dividend}></input>
                                        </div>
                                        </div>
                                        <div className="mt-1">
                                        <label className="fw-bold fs-6">Wam (Days):</label>
                                        <div>
                                            <input className="form-control" type="number" step="0.0001" id={`wam${value.id}`} defaultValue={value.wam}></input>
                                        </div>
                                        </div>
                                        <div className="mt-1">
                                        <label className="fw-bold fs-6">Duration (Days):</label>
                                        <div>
                                            <input className="form-control" type="number" step="0.0001" id={`duration${value.id}`} defaultValue={value.duration}></input>
                                        </div>
                                        </div>
                                    </div>
                                    <div className="mt-3 mx-auto" style={{width: "fit-content"}}>
                                        <button type="submit" className="btn btn-primary">Submit</button>
                                    </div>
                            </div>
                            </div>
                        </div>
                    </form>
                )
            })
        }
        <Box className="mx-auto mb-1 mt-1" sx={{ width: "98%" }}>
                  <Collapse in={alertopen}>
                      <Alert
                      severity={alertType}
                      action={
                          <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                              setalertOpen(false);
                          }}
                          >
                          <CloseIcon fontSize="inherit" />
                          </IconButton>
                      }
                      sx={{ mb: 2 }}
                      >
                      {AlertMessage}
                      </Alert>
                  </Collapse>
        </Box>
        <TableComponent
                    Data={data}
                    screenWidth={props.screenWidth}
                    MobViewRender={MobViewRender}
                    columnDefs={columnDefs}
                    datefilters={datefilters}
                    datefilter={false}
                    secp = {false}
                    detail = {'fund'}
                />
    </div>
  )
}
